export { default } from './TrendMetrics';
